var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-page-wrapper pdf-page"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("chineseNumber")(_vm.node.orderNumber))+"、"+_vm._s(_vm.node.treeDataItem.titleName))]),_c('div',{staticClass:"border"})]),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }